import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatError } from "../lib/api";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { identifier: identifier.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) { setError(formatError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <div className="flex items-center gap-3 mb-8">
          <img src="/dbs-logo.jpeg" alt="DBS FIELD" className="w-10 h-10 object-cover" style={{ borderRadius: 2 }} />
          <div className="label-caps" style={{ letterSpacing: "0.2em" }}>DBS FIELD</div>
        </div>

        <div className="card p-6">
          <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: "Chivo" }}>Esqueci minha senha</h2>
          <p className="text-sm mb-6" style={{ color: "var(--text-dim)" }}>
            Informe seu email ou nome de usuário. O administrador será notificado para gerar um link de recuperação e enviá-lo a você por um canal seguro.
          </p>

          {error && (
            <div className="mb-4 px-3 py-2 text-sm border" style={{ background: "rgba(239,68,68,0.08)", borderColor: "rgba(239,68,68,0.3)", color: "#FCA5A5" }}>{error}</div>
          )}

          {!submitted ? (
            <form onSubmit={submit}>
              <label className="label-caps block mb-1.5">Email ou usuário</label>
              <input
                className="input mb-4"
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                autoFocus
                data-testid="forgot-identifier"
              />
              <button type="submit" className="btn btn-primary w-full" disabled={loading} data-testid="forgot-submit">
                {loading ? "Enviando..." : "Solicitar recuperação"}
              </button>
            </form>
          ) : (
            <div data-testid="forgot-result" className="p-4 border" style={{ borderColor: "var(--border-strong)", background: "#0B1A2C" }}>
              <div className="flex items-start gap-3">
                <CheckCircle2 size={20} style={{ color: "var(--primary)", flexShrink: 0, marginTop: 2 }} />
                <div className="text-sm">
                  <b>Solicitação registrada.</b>
                  <div className="mt-1" style={{ color: "var(--text-dim)" }}>
                    Se a conta existir, o administrador foi notificado. Você receberá o link de recuperação em breve pelo canal habitual.
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="mt-6 pt-4 border-t text-center" style={{ borderColor: "var(--border)" }}>
            <Link to="/login" className="text-xs" style={{ color: "var(--primary)" }}>← Voltar para login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
